export default {
  Profile: 'profile.myProfileHeader',
  Chat: 'common.chat',
  Notifications: 'common.notifications',
  Settings: 'common.settings',
}
